import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>加载中...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export const PlatformRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>加载中...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_super !== 1 || user.adminShopId !== 1) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ProtectedRoute;